import React from "react";
import { connect } from "react-redux";
import Loader from "../../../../components/Loader/index";
import Analysis from "./Analysis";
import {
  fetchAdminResult,
  fetchResult,
  fetchDrivers
} from "../../../../modules/results/actions";

class AnalysisContainer extends React.Component {
  componentDidMount() {
    const { id } = this.props.match.params;
    this.props.fetchAdminResult(id);
    this.props.fetchResult(id);
    this.props.fetchDrivers(id);
  }

  render() {
    const { protocol, hostname, pathname } = window.location;
    const shareUrl = `${protocol}//${hostname}${pathname.replace(
      "/results",
      ""
    )}`;    
    return this.props.result ? (
      <Analysis {...this.props} shareUrl={shareUrl} />
    ) : (
      <Loader />
    );
  }
}

function mapStateToProps(state) {
  return {
    result: state.results.result,
    drivers: state.results.drivers,
    owner: state.results.owner,
    groupedByCategory: state.results.groupedByCategory,
    language: state.preference.language,
    author: state.results.adminResult.author,
    answers: state.results.adminResult.answers,
    peer1: state.results.adminResult.peer1,
    peer2: state.results.adminResult.peer2,
    peer3: state.results.adminResult.peer3,
    loading: state.results.loading,
    peer1Name: state.results.peer1Name,
    peer2Name: state.results.peer2Name,
    peer3Name: state.results.peer3Name
  };
}

const mapActionsToProps = {
  fetchAdminResult,
  fetchResult,
  fetchDrivers
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(AnalysisContainer);



// WEBPACK FOOTER //
// ./src/pages/Admin/ResultDocument/ResultTADocument/container.js